import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable()
export class BaseService
{
	constructor()
	{
	}

	public handleError(error: any): Promise<any>
	{
		if (error.status === 401)
		{
			// The request was not authenticated, redirect to the login page.
			window.location.href = environment.login_url;

			return Promise.resolve();
		}
		return Promise.resolve(error);
	}
}



// WEBPACK FOOTER //
// ./src/app/base.service.ts